import React from 'react';
import { useNavigate } from 'react-router-dom';
import '../styles/FloatingCartButton.css';

const FloatingCartButton = ({ cartItems }) => {
    const navigate = useNavigate();

    return (
        <div
            className="floating-cart-button"
            onClick={() => navigate('/cart')}
        >
            Подивитися моє замовлення ({cartItems})
        </div>
    );
};

export default FloatingCartButton;
